import React, { useState, useEffect } from 'react'
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView'
import { apiGet } from '../../generic/Api_Functions'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { CustomTreeItem, ExpandIcon, CollapseIcon, EndIcon } from '../../generic/CustomTreeItem'

const Structure = ({ partReference }) => {
  const [currentPartStructure, setCurrentPartStructure] = useState(null)
  const { t_ } = useSmartTranslation()

  const getResourceTypeLabel = (resourceType) => {
    switch (resourceType) {
      case 'PART_REFERENCE':
        return t_('Part')
      case 'RAW_MATERIAL_REFERENCE':
        return t_('Raw material')
      default:
        return resourceType
    }
  }

  useEffect(() => {
    const fetchPartStructure = async () => {
      try {
        const partStructure = await apiGet('workflows/resourceStructure/' + partReference)
        setCurrentPartStructure(partStructure)
      } catch (error) {
        console.error('Error fetching part structure:', error)
      }
    }

    fetchPartStructure()
  }, [partReference])

  const renderTree = (nodes, parentId = '') => (
    <CustomTreeItem
      key={parentId + '-' + nodes.id + '-' + nodes.resourceType}
      itemId={parentId + '-' + nodes.id + '-' + nodes.resourceType}
      label={nodes.code + ' (' + nodes.quantity + ') - ' + getResourceTypeLabel(nodes.resourceType)}
    >
      {Array.isArray(nodes.resourceChildren) && nodes.resourceChildren.length > 0
        ? nodes.resourceChildren.map((child, index) => renderTree(child, `${parentId}-${nodes.id}-${index}`))
        : null}
    </CustomTreeItem>
  )

  return (
    <div style={{ width: '100%', maxWidth: '300px' }}>
      {currentPartStructure === null
        ? (
          <p>{t_('Loading data...')}</p>
          )
        : currentPartStructure.length === 0
          ? (
            <p>{t_('There is no resource')}</p>
            )
          : (
            <div style={{ maxHeight: '80vh', overflowY: 'auto', minHeight: '100px', padding: '0.5rem' }}>
              <SimpleTreeView
                aria-label='customized'
                defaultExpandedItems={['1']}
                slots={{
                  expandIcon: ExpandIcon,
                  collapseIcon: CollapseIcon,
                  endIcon: EndIcon
                }}
                sx={{ overflowX: 'hidden', flexGrow: 1 }}
              >
                {currentPartStructure.map((node, index) => renderTree(node, index.toString()))}
              </SimpleTreeView>
            </div>
            )}
    </div>
  )
}

export default Structure
